module.exports = __webpack_public_path__ + "img/yes.ee7e27f6.svg";